import type { Dispatch, SetStateAction } from 'react';
import { useEffect, useCallback, useMemo } from 'react';

export interface UseLoadMoreProductsParams {
  allowedFavoriteProductCodes: string[];
  areFavoriteProductCodesLoaded: boolean;
  getFavoriteProductsCalled: boolean;
  chunkSize: number;
  setAmountToLoad: Dispatch<SetStateAction<number>>;
}

export const useLoadMoreProducts = ({
  allowedFavoriteProductCodes,
  areFavoriteProductCodesLoaded,
  chunkSize,
  getFavoriteProductsCalled,
  setAmountToLoad,
}: UseLoadMoreProductsParams) => {
  const maxAmountToLoad = useMemo(
    () => allowedFavoriteProductCodes.length,
    [allowedFavoriteProductCodes.length],
  );
  const loadMoreProducts = useCallback(
    (amount = chunkSize, maxAmount = maxAmountToLoad) => {
      setAmountToLoad((prevAmount) =>
        prevAmount + amount >= maxAmount ? maxAmount : prevAmount + amount,
      );
    },
    [maxAmountToLoad, chunkSize, setAmountToLoad],
  );
  useEffect(() => {
    if (areFavoriteProductCodesLoaded && !getFavoriteProductsCalled) {
      loadMoreProducts();
    }
  }, [areFavoriteProductCodesLoaded, getFavoriteProductsCalled, loadMoreProducts]);

  return { loadMoreProducts };
};
